export class CustomerSourceGroup {
    name = null;
    code = null;
}